import React from 'react';
import {
  Box,
  Typography,
  TextField,
  Button,
  IconButton,
  FormControlLabel,
  Checkbox,
  CircularProgress
} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

const EnterPracticeNpiStep = ({
  usePersonalNpi,
  practiceNpi,
  error,
  loading,
  onToggleUsePersonal,
  onPracticeNpiChange,
  onValidate,
  onBack,
  onOpenClearDialog
}) => (
  <Box sx={{ maxWidth: 400 }}>
    <Typography variant="h6" gutterBottom>
      Enter Practice NPI
    </Typography>
    <Typography variant="body2" color="text.secondary" gutterBottom>
      You can either use your personal NPI number for your practice or enter a separate practice NPI number (NPI-2).
    </Typography>
    <Box sx={{ mt: 2 }}>
      <FormControlLabel
        control={<Checkbox checked={usePersonalNpi} onChange={(e) => onToggleUsePersonal(e.target.checked)} />}
        label="Use my personal NPI number for my practice"
      />
      {!usePersonalNpi && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 2 }}>
          <TextField
            fullWidth
            label="Practice NPI Number"
            value={practiceNpi}
            onChange={onPracticeNpiChange}
            error={!!error}
            helperText={error}
          />
          {practiceNpi && (
            <IconButton onClick={onOpenClearDialog} sx={{ mt: 1 }}>
              <ClearIcon />
            </IconButton>
          )}
        </Box>
      )}
      <Button
        variant="contained"
        onClick={onValidate}
        disabled={loading}
        sx={{ mt: 2 }}
      >
        {loading ? <CircularProgress size={24} /> : (usePersonalNpi ? 'Continue' : 'Validate Practice NPI')}
      </Button>
    </Box>
    <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
      <Button variant="outlined" onClick={onBack}>
        Back
      </Button>
    </Box>
  </Box>
);

export default EnterPracticeNpiStep;